const routes = [
    {
        path: "/prep/exam/scores/entry",
        component: () => import("../pages/Entry"),
        meta: {
            isAuthenticated: true,
            permission: "prepexamscore_index"
        }
    }
];

export default routes;
